import styled from "styled-components";

const Notes = styled.div`
  & > * {
    margin: 8px 0;
  }
  margin-top: -8px;
`;

const StyledNoteList = styled.div``;

export default StyledNoteList;
export { Notes };
